<template>
  <div class="app-container">
    <el-form :model="searchData" :inline="true" label-width="140px" label-position="right" ref="searchData">
      <el-form-item label="京东工单号" prop="orderNo">
        <el-input v-model="searchData.orderNo" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="回收订单号" prop="recycleNo">
        <el-input v-model="searchData.recycleNo" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="旧机条码" prop="oldBarCode">
        <el-input v-model="searchData.oldBarCode" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="异常情况" prop="exceptionType">
        <el-select v-model="searchData.exceptionType" placeholder="请选择状态" clearable>
          <el-option v-for="(item, index) in JdExceptionTypeEnum" :key="index" :label="item.description" :value="item.enumCode"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="省" prop="provinceId">
        <el-select v-model="searchData.provinceId" placeholder="请选择" clearable style="width: 100%" @change="provinceChangeFun">
          <el-option v-for="item in provinceListNew" :key="item.provinceId" :label="item.province" :value="item.provinceId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="市" prop="cityIds">
        <el-select v-model="searchData.cityIds" multiple placeholder="请选择" clearable style="width: 100%" :disabled="isCityDisabled">
          <el-option v-for="item in cityListNew" :key="item.cityId" :label="item.city" :value="item.cityId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="网点名称" prop="stationName">
        <el-input v-model="searchData.stationName" placeholder="请输入" clearable maxlength="20"></el-input>
      </el-form-item>
      <el-form-item label="京东完成时间" prop="finishDate">
        <el-date-picker
          v-model="searchData.finishDate"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="getDateRangePickerOptions('finishDate')"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="报备时间" prop="stationReportDate">
        <el-date-picker
          v-model="searchData.stationReportDate"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="getDateRangePickerOptions('stationReportDate')"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="回收完成时间" prop="recycleCompleteDate">
        <el-date-picker
          v-model="searchData.recycleCompleteDate"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="getDateRangePickerOptions('recycleCompleteDate')"
        >
        </el-date-picker>
      </el-form-item>
    </el-form>
    <div class="btn-group">
      <div class="row-bg">
        <el-button type="primary" size="medium" @click="exportTbleFun" :loading="exportFlag">导出</el-button>
      </div>
      <div class="row-bg">
        <el-button type="primary" size="medium" @click="handleSearch()">查询</el-button>
        <el-button size="medium" @click="resetForm()">重置</el-button>
      </div>
    </div>

    <el-table ref="checktableData" :data="tableData" v-loading="tableLoading" :reserve-selection="true" center height="60vh">
      <el-table-column label="操作" prop="action" min-width="120">
        <template slot-scope="scope">
          <el-link type="primary" @click="handleDetail(scope.row)">详情</el-link>
        </template>
      </el-table-column>
      <el-table-column label="京东工单号" prop="orderNo" min-width="140"> </el-table-column>
      <el-table-column label="回收订单号" prop="recycleNo" min-width="140"> </el-table-column>
      <el-table-column label="旧机条码1" prop="oldBarCode1" min-width="140"> </el-table-column>
      <el-table-column label="旧机条码2" prop="oldBarCode2" min-width="140"> </el-table-column>
      <el-table-column label="旧机类型" prop="thirdOldCate" min-width="140"> </el-table-column>
      <el-table-column label="省" prop="province" min-width="100"> </el-table-column>
      <el-table-column label="市" prop="city" min-width="100"> </el-table-column>
      <el-table-column label="异常情况" prop="exceptionType" min-width="140">
        <template slot-scope="scope">
          {{ getExceptionTypeDesc(scope.row.exceptionType) }}
        </template>
      </el-table-column>
      <el-table-column label="报备时间" prop="stationReportDate" min-width="140"> </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes,prev, pager, next,jumper"
        :current-page.sync="pagination.page"
        :page-size="pagination.rows"
        :page-sizes="[10, 20, 30, 50]"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import enumMixin from '../COldForNewService/enumMixin'
import jdProvinceCity from './mixins/jdProvinceCity'

const createDefaultSearchData = () => ({
  orderNo: undefined,
  recycleNo: undefined,
  oldBarCode: undefined,
  exceptionType: undefined,
  provinceId: undefined,
  cityIds: [],
  stationName: undefined,
  finishDate: [],
  stationReportDate: [],
  recycleCompleteDate: []
})

const createPickerDateState = () => ({
  finishDate: null,
  stationReportDate: null,
  recycleCompleteDate: null
})

export default {
  components: {},
  mixins: [enumMixin, jdProvinceCity],
  data() {
    return {
      searchData: createDefaultSearchData(),
      tableData: [],
      tableLoading: false,
      pagination: {
        page: 1,
        rows: 10
      },
      total: 0,
      exportFlag: false,
      rangeLimitDays: 365,
      pickerDateState: createPickerDateState()
    }
  },
  computed: {
    isCityDisabled() {
      return !this.searchData.provinceId
    }
  },
  created() {
    this.handleSearch()
  },
  methods: {
    // 查询
    handleSearch() {
      this.pagination.page = 1
      this.getList()
    },
    // 清空
    resetForm() {
      this.searchData = createDefaultSearchData()
      this.cityListNew = []
      this.pickerDateState = createPickerDateState()
      this.getList()
    },
    // 查看详情
    handleDetail(rowData) {
      // console.log('====rowData', rowData)
      const orderNo = rowData.orderNo
      this.$router.push({
        path: '/jdOldMachineRecycleManage/reportBranchExceptionDetail',
        query: { orderNo }
      })
    },

    // 当前页改变
    handleSizeChange(val) {
      this.pagination.page = 1
      this.pagination.rows = val
      this.getList()
    },
    // 页码改变
    handleCurrentChange(val) {
      this.getList()
    },
    // 省改变
    provinceChangeFun() {
      this.searchData.cityIds = []
      if (this.searchData.provinceId) {
        this.getTblCityNew(this.searchData.provinceId)
      } else {
        this.cityListNew = []
      }
    },
    // 时间范围选择限制
    getDateRangePickerOptions(field) {
      return {
        disabledDate: time => {
          const selectedMinDate = this.pickerDateState[field]
          if (!selectedMinDate) return false

          const current = dayjs(time)
          const minDate = dayjs(selectedMinDate)
            .subtract(this.rangeLimitDays, 'day')
            .startOf('day')
          const maxDate = dayjs(selectedMinDate)
            .add(this.rangeLimitDays, 'day')
            .endOf('day')
          return current.isBefore(minDate) || current.isAfter(maxDate)
        },
        onPick: ({ maxDate, minDate }) => {
          if (!minDate) {
            this.pickerDateState[field] = null
            return
          }

          this.pickerDateState[field] = maxDate ? null : minDate
          if (maxDate) {
            const diffDays = dayjs(maxDate).diff(dayjs(minDate), 'day')
            if (diffDays > this.rangeLimitDays) {
              this.$set(this.searchData, field, [])
              this.$message.warning('时间范围最大支持1年')
            }
          }
        }
      }
    },
    // 组装时间范围参数
    buildDateRangeParams(dateRange = [], fieldName) {
      // 处理 dateRange 为 null 的情况
      if (!dateRange || !Array.isArray(dateRange)) {
        dateRange = []
      }
      return {
        [`start${fieldName}`]: dateRange[0] ? `${dateRange[0]} 00:00:00` : undefined,
        [`end${fieldName}`]: dateRange[1] ? `${dateRange[1]} 23:59:59` : undefined
      }
    },
    // 组装查询参数
    buildQueryParams() {
      const { finishDate, stationReportDate, recycleCompleteDate, cityIds = [], stationName, ...restSearchData } = this.searchData

      return {
        ...restSearchData,
        stationName: stationName ? stationName.trim() : undefined,
        ...this.buildDateRangeParams(finishDate, 'FinishDate'),
        ...this.buildDateRangeParams(stationReportDate, 'StationReportDate'),
        ...this.buildDateRangeParams(recycleCompleteDate, 'RecycleCompleteDate'),
        provinceId: this.searchData.provinceId || undefined,

        cityIds: cityIds.length ? cityIds : undefined,
        cityId: cityIds.length === 1 ? cityIds[0] : undefined,
        ...this.pagination
      }
    },
    getList() {
      const url = '/autoapp-default-server-recovery/api/jd/stationReport/pageCondition'
      const params = this.buildQueryParams()
      this.tableLoading = true
      this.HttpService.post(url, params).then(res => {
        if (res.statusCode === 200) {
          // console.log('res===', res)
          const resData = res.data.records || []
          const total = res.data.total || 0
          this.tableData = resData
          this.total = total
        } else {
          const msgTip = res.message || '请求出错'
          this.$message.error(msgTip)
        }
        this.tableLoading = false
      })
    },
    // 导出
    exportTbleFun() {
      this.exportFlag = true
      setTimeout(() => {
        this.exportFlag = false
      }, 1200)
      const url = '/autoapp-default-server-recovery/api/jd/stationReport/export/pageCondition'
      const params = this.buildQueryParams()
      this.HttpService.post(url, params).then(res => {
        if (res.statusCode == 200) {
          this.$message.success('正在导出, 稍后请到下载中心查看')
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    // 获取异常情况描述
    getExceptionTypeDesc(exceptionType) {
      const exceptionMap = {
        1: '无连接管',
        2: '连接管剪断',
        3: '连接管为铝管',
        4: '用户品牌不一致',
        5: '旧机面板缺失',
        6: '其他'
      }
      return exceptionMap[exceptionType] || ''
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.row-bg {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.upload-demo {
  margin: 0 12px;
}
.btn-group {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/jdOldMachineRecycleManage/reportBranchExceptionSearch.vue